<script lang="ts">
  import { createEventDispatcher } from 'svelte'

  export let label: string

  const dispatch = createEventDispatcher<{
    'click': () => void
  }>()
</script>

<button 
  type="button"
  on:click={() => dispatch('click')}
>
  {label}
</button>

<style lang="scss">
  button {
    font-weight: 600;
    line-height: 20px;
    text-align: center;
    color: white;
    padding: 16px 32px;
    background-color: #2B50ED;
    border: none;
    border-radius: 30px;
    cursor: pointer;
  }
</style>